import { ContentGroupKeys } from '../google-analytics';

const getZlogsType = ({ pageCategory }, state) => ({
    group: ContentGroupKeys.ZlogPageType,
    value: pageCategory(state),
});

const getZlogsCategory = ({ rollUpBucket }, state) => ({
    group: ContentGroupKeys.ZlogRollupBucket,
    value: rollUpBucket(state),
});

export default function getContentGroups({ analytics, state }) {
    return [
        getZlogsType(analytics, state),
        getZlogsCategory(analytics, state),
    ];
}
